import { DEFAULT_TIMEZONE } from 'app-config';

import { timezoneStorageKey } from './timezone';

export const getUserTimezone = (): number => {
  const storageTimezone = localStorage.getItem(timezoneStorageKey);

  if (storageTimezone !== null && !Number.isNaN(storageTimezone)) {
    return Number(storageTimezone);
  }

  localStorage.setItem(timezoneStorageKey, JSON.stringify(DEFAULT_TIMEZONE));
  return DEFAULT_TIMEZONE;
};

export const setUserTimezoneToLocalstorage = (selectedTimezone: string | number): void => {
  if (typeof selectedTimezone === 'string' && !Number.isNaN(selectedTimezone)) {
    localStorage.setItem(timezoneStorageKey, JSON.stringify(Number(selectedTimezone)));
  } else {
    localStorage.setItem(timezoneStorageKey, JSON.stringify(selectedTimezone));
  }
};
